import nexus from '@db2b/nexus-js'
import Echo from 'laravel-echo'
import io from 'socket.io-client'

export let echo = new Echo({
  broadcaster: 'socket.io',
  host: nexus.eventEndpoint(),
  client: io
})



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/services/echo.js